import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalHeader,
  Row
} from "reactstrap";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
//Import Common Component
import {
  ErrorModal,
  RavenAgTable,
} from "components/Common/CombinedComponents";

import { getTitleValue, getDateTime } from "components/Common/TableComponents/AgTable/CellRenderers/CellFunctions";

import { withTranslation } from "react-i18next";


import {
  getPayOutStatusDefList,
  getMerchantPaymentFileList,
  getMerchantPaymentDetailList,
  merchantPaymentFileApiError
} from "../../store/actions";

import SearchContentMerchantPaymentFile from "./merchantReconciliationSearchContent"

class MerchantPaymentFile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      recordList: [],
      detailRecordList: [],
      record: "",
      errorModal: false,
      addAnother: false,
      isedit: false,
      isDetail: false,
      activeTab: "1",
      detailRecordColumns: [
        {
          headerName: this.props.t("orderId"),
          field: "transactionProvisionSettle.orderId",
        },
        {
          headerName: this.props.t("paymentId"),
          field: "transactionProvisionSettle.paymentId",
        },
        {
          headerName: this.props.t("cardNo"),
          field: "transactionProvisionSettle.cardNo",
        },
        {
          headerName: this.props.t("cardType"),
          field: "transactionProvisionSettle.cardType.name",
        },
        {
          headerName: this.props.t("transactionAmount"),
          field: "transactionProvisionSettle.f004",
        },
        {
          headerName: this.props.t("payFacCommissionRate"),
          field: "payFacCommissionRate",
        },
        {
          headerName: this.props.t("payFacCommissionAmount"),
          field: "payFacCommissionAmount",
        },
        {
          headerName: this.props.t("installmentType"),
          field: "transactionProvisionSettle.installmentType.name",
        },
        {
          headerName: this.props.t("installmentCount"),
          field: "transactionProvisionSettle.installmentCount",
        },
        {
          headerName: this.props.t("eodDate"),
          field: "merchantPayment.eodDate",
          filter: "agDateTimeColumnFilter",
          cellRenderer: "dateTimeCellRender",
          filterParams: { valueFormatter: getDateTime },
        },
        {
          headerName: this.props.t("paymentDate"),
          field: "merchantPayment.paymentDate",
          filter: "agDateTimeColumnFilter",
          cellRenderer: "dateTimeCellRender",
          filterParams: { valueFormatter: getDateTime },
        }
      ],
      recordcolumns: [
        {
          headerName: this.props.t("merchantId"),
          field: "merchantPayment.merchant.merchantId",
        },
        {
          headerName: this.props.t("bankName"),
          field: "merchantPayment.domesticBank.bankName",
        },
        {
          headerName: this.props.t("iban"),
          field: "merchantPayOut.iban",
        },
        {
          headerName: this.props.t("currency"),
          field: "merchantPayment.currency.currencyName",
        },
        {
          headerName: this.props.t("eodDate"),
          field: "merchantPayment.eodDate",
          filter: "agDateTimeColumnFilter",
          cellRenderer: "dateTimeCellRender",
          filterParams: { valueFormatter: getDateTime },
        },
        {
          headerName: this.props.t("paymentDate"),
          field: "merchantPayment.paymentDate",
          filter: "agDateTimeColumnFilter",
          cellRenderer: "dateTimeCellRender",
          filterParams: { valueFormatter: getDateTime },
        },
        {
          headerName: this.props.t("payOutStatus"),
          field: "payOutStatus.description",
        },
        {
          headerName: this.props.t("ravenTransactionType"),
          field: "merchantPayment.ravenTransactionType.description",
        },
        {
          headerName: this.props.t("totalRecordCount"),
          field: "merchantPayment.totalRecordCount",
        },
        {
          headerName: this.props.t("totalAmount"),
          field: "merchantPayment.totalAmount",
        },
        {
          headerName: this.props.t("totalNetAmount"),
          field: "merchantPayment.totalNetAmount",
        },
        {
          headerName: this.props.t("totalPayFacCommissionAmount"),
          field: "merchantPayment.totalPayFacCommissionAmount",
        },
        {
          headerName: this.props.t("totalBsmv"),
          field: "merchantPayment.totalPayFacBsmvAmount",
        },
        {
          headerName: this.props.t("totalTransactionAmountTL"),
          field: "merchantPayment.totalTransactionAmountTL",
        },
        {
          headerName: this.props.t("totalPayFacCommissionAmountTL"),
          field: "merchantPayment.totalPayFacCommissionAmountTL",
        },
        {
          headerName: this.props.t("totalPayFacBsmvAmountTL"),
          field: "merchantPayment.totalPayFacBsmvAmountTL",
        },
        {
          headerName: this.props.t("insertDatetime"),
          field: "insertDatetime",
          filter: "agDateTimeColumnFilter",
          hide: true,
          cellRenderer: "dateTimeCellRender",
          filterParams: { valueFormatter: getDateTime },
        },
        {
          headerName: this.props.t("updateDateTime"),
          field: "updateDateTime",
          filter: "agDateTimeColumnFilter",
          hide: true,
          cellRenderer: "dateTimeCellRender",
          filterParams: { valueFormatter: getDateTime },
        },
        {
          headerName: this.props.t("merchantPaymentType"),
          field: "merchantPayment.merchantPaymentType.name",
        },
        {
          headerName: this.props.t("paymentStatusDescription"),
          field: "paymentStatusDescription",
        },
        {
          headerName: this.props.t("paymentStatusCode"),
          field: "paymentStatusCode",
        },
      ],
    };

    this.toggle = this.toggle.bind(this);
    this.toggleTab = this.toggleTab.bind(this);
    this.handleAddRecordClick = this.handleAddRecordClick.bind(this);
    this.handleDetailClick = this.handleDetailClick.bind(this);
    this.SearchContent = this.SearchContent.bind(this);
  }

  //#region Base Operations
  componentDidMount() {
    this.props.apiError("");

    const { onGetRecordList, 
      onGetPayOutStatusRecordList } = this.props;

    onGetRecordList({ userName: localStorage.getItem("username") });
    onGetPayOutStatusRecordList();
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { error } = this.props;
    if (prevProps.error !== error) {
      this.setState({ error: error });
    }
  }


  //#endregion

  //#region Cruid Operations

  handleAddRecordClick = () => {
    this.setState({ record: "", isEdit: false });
    this.toggle();
  };
  handleDetailClick = values => {
    const { onGetDetailRecordList } = this.props;
    onGetDetailRecordList(values.merchantPaymentGuid)

    this.setState({
      record: values,
      addAnother: false,
      isDetail: true,
      isEdit: false,
      activeTab: "1",
    });
    this.toggle();
  };
  SearchContent() {
    return <SearchContentMerchantPaymentFile />
  }

  //#endregion

  //#region Dom Elements Design


  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));
    if (this.state.modal) {
      setTimeout(() => this.setState({ isDetail: false }), 150);
    }
  }

  //#endregion
  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }
  render() {
    const { recordList, detailRecordList } = this.props;
    const { error } = this.state;
    return (
      <React.Fragment>
        {error && (<ErrorModal errorMessage={error} onCloseModalClick={() => this.setState({ error: undefined })} />)}
        <ToastContainer />
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <RavenAgTable
                      SearchContent={this.SearchContent}
                      onDetailClick={this.handleDetailClick}
                      actionItems={true}
                      exportOption={true}
                      recordcolumns={this.state.recordcolumns}
                      recordList={recordList}
                      breadCrumbTitle={this.props.t("reconciliationManagement")}
                      breadCrumbItem={this.props.t("merchantReconciliation")}
                    />
                    <Modal
                      isOpen={this.state.modal}
                      className={this.props.className}
                      onClose={this.toggleModalClose}
                      size="xl"
                      backdrop={"static"}
                      id="staticBackdrop"
                    >
                      <ModalHeader toggle={this.toggle} tag="h4">
                        {this.props.t("merchantReconciliationDetail")}
                      </ModalHeader>
                      <ModalBody>
                        <RavenAgTable
                          exportOption={true}
                          recordcolumns={this.state.detailRecordColumns}
                          recordList={detailRecordList}
                        />
                      </ModalBody>
                    </Modal>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>

      </React.Fragment>

    );
  }
}

MerchantPaymentFile.propTypes = {
  recordList: PropTypes.array,
  onGetRecordList: PropTypes.func,
  className: PropTypes.any,
  apiError: PropTypes.any,
  error: PropTypes.any,
  t: PropTypes.any,
  payOutStatusRecordList: PropTypes.array,
  onGetPayOutStatusRecordList: PropTypes.func,
  detailRecordList: PropTypes.array,
  onGetDetailRecordList: PropTypes.func,
};

const mapStateToProps = ({ merchantPaymentFile, payOutStatusDef, }) => ({
  recordList: merchantPaymentFile.recordList,
  error: merchantPaymentFile.error,
  payOutStatusRecordList: payOutStatusDef.recordList,
  detailRecordList: merchantPaymentFile.detailRecordList
});

const mapDispatchToProps = dispatch => ({
  onGetRecordList: record => dispatch(getMerchantPaymentFileList(record)),
  apiError: error => dispatch(merchantPaymentFileApiError(error)),
  onGetPayOutStatusRecordList: () => dispatch(getPayOutStatusDefList()),
  onGetDetailRecordList: guid => dispatch(getMerchantPaymentDetailList(guid)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(MerchantPaymentFile));
